import React from 'react';
import styled from 'styled-components';
import { legacyType } from '../../styles/typography';
import { transparentize, setLightness, darken } from 'polished';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';

function without(props, obj) {
  const copy = { ...obj };
  props.forEach(prop => delete copy[prop]);
  return copy;
}
// color(var, a(opacity)) seems to not work, needs investigatiom

const ButtonBase = `
  border-width: 2px;
  border-style: solid;
  cursor: pointer;
  display: inline-block;
  font-size: var(--fs-base);
  font-weight: 500;
  ${legacyType('xs', 'label', { uppercase: true, lineHeight: false }).join('')}
  line-height: 1rem;
  padding: .5rem 2rem;
  position: relative;
  text-align: center;
  text-transform: uppercase;
  transition-duration: .33s;
  transition-property: background-color, background-color;
  text-decoration: none !important;
`;

export const ButtonWrapper = styled(({ link, openInNewTab, ...props }) => {
  const notStylingProps = without(['color', 'outline', 'theme'], props);

  if (!link) {
    return <button {...notStylingProps} />;
  }

  if (openInNewTab) {
    return (
      <a {...notStylingProps} href={link} target="_blank" rel="noopener noreferrer" aria-label="" />
    );
  }

  return <a {...notStylingProps} href={link} aria-label="" />;
})`
  ${ButtonBase}
  width: ${({ fullWidth }) => {
    return fullWidth ? '100%' : 'auto';
  }} !important;
  color: ${({ color, outline, theme }) => {
    if (outline === 'white') return theme.white;
    if (outline === 'black') return theme.shark;
    if (color === 'white' || color === 'transparent') return theme.black;
    return theme.white;
  }};
  background-color: ${({ color, outline, theme }) => {
    if (color === 'red') return theme.red;
    if (color === 'white') return theme.white;
    if (outline) return 'transparent';
    return theme.shark;
  }};
  border-color: ${({ outline, theme }) => {
    if (outline === 'black') return theme.shark;
    if (outline === 'white') return theme.white;
    return 'transparent';
  }};
  &:hover {
    background-color: ${({ color, outline, theme }) => {
      if (outline === 'white') return darken(0.5, theme.white);
      if (outline === 'black') return transparentize(0.95, theme.shark);
      if (color === 'red') return setLightness(0.64, theme.red);
      if (color === 'white') return transparentize(0.5, theme.white);
      return theme.main;
    }};
    border-color: ${({ outline, theme }) => {
      if (outline === 'black') return theme.shark;
      if (outline === 'white') return theme.white;
      return 'transparent';
    }};
  }
  &:disabled {
    background-color: ${({ color, theme }) => (color === 'red' ? theme.redDisabled : theme.black)};
    border-color: ${({ color, theme }) => (color === 'red' ? theme.redDisabled : theme.main)};
  }
`;

const Button = ({
  link,
  openInNewTab,
  children,
  color,
  outline,
  theme,
  onClick,
  className,
  fullWidth,
  disabled,
  intl,
}) => {
  return (
    <ButtonWrapper
      color={color}
      outline={outline}
      theme={theme}
      onClick={onClick}
      link={link}
      openInNewTab={openInNewTab}
      className={className}
      disabled={disabled}
      intl={intl}
      fullWidth={fullWidth}
    >
      {children}
    </ButtonWrapper>
  );
};

Button.propTypes = {
  link: PropTypes.string,
  openInNewTab: PropTypes.bool,
  children: PropTypes.node,
  color: PropTypes.string,
  outline: PropTypes.string,
  theme: PropTypes.object,
  onClick: PropTypes.func,
  className: PropTypes.string,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  intl: intlShape.isRequired,
};

export default injectIntl(Button);



// WEBPACK FOOTER //
// /tmp/build_2cb81483/src/components/common/Button.js